const AuthenticationConstants = {
  LOGIN: 'SR_AUTHENTICATION_LOGIN',
  LOGIN_SUCCESS: 'SR_AUTHENTICATION_LOGIN_SUCCESS',
  LOGIN_FAIL: 'SR_AUTHENTICATION_LOGIN_FAIL',
  LOGIN_WITH_OKTA: 'SR_AUTHENTICATION_LOGIN_WITH_OKTA',
  RELOGIN: 'SR_AUTHENTICATION_RELOGIN',
  RELOGIN_FAIL: 'SR_AUTHENTICATION_RELOGIN_FAIL',
  LOGOUT: 'SR_AUTHENTICATION_LOGOUT',
  LOGOUT_SUCCESS: 'SR_AUTHENTICATION_LOGOUT_SUCCESS',
  FORGOT_PASSWORD: 'SR_AUTHENTICATION_FORGOT_PASSWORD',
  FORGOT_PASSWORD_SUCCESS: 'SR_AUTHENTICATION_FORGOT_PASSWORD_SUCCESS',
  FORGOT_PASSWORD_FAIL: 'SR_AUTHENTICATION_FORGOT_PASSWORD_FAIL',
  RESET_PASSWORD: 'SR_AUTHENTICATION_RESET_PASSWORD',
  RESET_PASSWORD_SUCCESS: 'SR_AUTHENTICATION_RESET_PASSWORD_SUCCESS',
  RESET_PASSWORD_FAIL: 'SR_AUTHENTICATION_RESET_PASSWORD_FAIL',
  CHANGE_PASSWORD: 'SR_AUTHENTICATION_CHANGE_PASSWORD',
  CHANGE_PASSWORD_RESET: 'SR_AUTHENTICATION_CHANGE_PASSWORD_RESET',
  CHANGE_PASSWORD_SUCCESS: 'SR_AUTHENTICATION_CHANGE_PASSWORD_SUCCESS',
  CHANGE_PASSWORD_FAIL: 'SR_AUTHENTICATION_CHANGE_PASSWORD_FAIL',
  GET_LOGON_METHODS_SUCCESS: 'SR_AUTHENTICATION_GET_LOGON_METHODS_SUCCESS',
  GET_LOGON_METHODS_FAIL: 'SR_AUTHENTICATION_GET_LOGON_METHODS_FAIL',
  GET_SESSION_ID_SUCCESS: 'SR_AUTHENTICATION_GET_SESSION_ID_SUCCESS',
  GET_SESSION_ID_FAIL: 'SR_AUTHENTICATION_GET_SESSION_ID_FAIL',
  TOGGLE_SLIDE_OUT: 'SR_AUTHENTICATION_TOGGLE_SLIDE_OUT',
  HIDE_SLIDE_OUT: 'SR_AUTHENTICATION_HIDE_SLIDE_OUT',
  CLEAR_FORGOT_PASSWORD_EMAIL_SENT: 'SR_AUTHENTICATION_CLEAR_FORGOT_PASSWORD_EMAIL_SENT',
  SET_SESSION_WARNING_MODE: 'SR_AUTHENTICATION_SET_SESSION_WARNING_MODE',
  EXTEND_SESSION: 'SR_AUTHENTICATION_EXTEND_SESSION',
  GET_SERVER_VERSION_SUCCESS: 'SR_AUTHENTICATION_GET_SERVER_VERSION_SUCCESS',
  GET_SERVER_VERSION_FAIL: 'SR_AUTHENTICATION_GET_SERVER_VERSION_FAIL'
};

export default AuthenticationConstants;
